module.exports = __webpack_public_path__ + "img/arrow-angle-right-tx-more.5c479e33.svg";